import { useState } from "react";
import { readFile } from "../services/readFile";
import { handleErrorMessage } from "../lib/utils";

export function useReadFile() {
	const [isLoading, setIsLoading] = useState(false);

	const readTextFile = async (file: File, maxSymbols = 10000) => {
		setIsLoading(true);

		return readFile(file, maxSymbols)
			.then(({ text }) => {
				return text;
			})
			.catch((error) => {
				handleErrorMessage(error, "Error reading file");
				throw error;
			})
			.finally(() => setIsLoading(false));
	};

	return { readTextFile, isLoading };
}
